import { ActivatedRoute, NavigationEnd, NavigationExtras, PRIMARY_OUTLET, Router } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators';

@Component({
	selector: 'app-breadcrumbs',
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {
	title: any;
	role_id: any = '';
	breadcrumbs: any;
	url: string;

	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private _location: Location,
		private elementRef: ElementRef
	) {
		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.pipe(map(() => this.activatedRoute))
			.pipe(
				map((route) => {
					while (route.firstChild) {
						route = route.firstChild;
					}
					return route;
				})
			)
			.pipe(filter((route) => route.outlet === PRIMARY_OUTLET))
			.subscribe((route) => {
				let snapshot = this.router.routerState.snapshot;
				let title = route.snapshot.data['title'];
				let parent = route.parent.snapshot.data['breadcrumb'];
				let child = route.snapshot.data['breadcrumb'];
				let childurl = route.snapshot.data['breadcrumburl'];
				let child1 = route.snapshot.data['breadcrumb1'];
				let child1url = route.snapshot.data['breadcrumb1url'];
				let child2 = route.snapshot.data['breadcrumb2'];
				let child2url = route.snapshot.data['breadcrumb2url'];
				let child3 = route.snapshot.data['breadcrumb3'];
				let child3url = route.snapshot.data['breadcrumb3url'];
				let child4 = route.snapshot.data['breadcrumb4'];
				let child4url = route.snapshot.data['breadcrumb4url'];
				this.breadcrumbs = {};
				this.title = title;
				this.breadcrumbs = {
					parentBreadcrumb: parent,
					childBreadcrumb: child,
					childBreadcrumb1: child1,
					childBreadcrumb2: child2,
					childBreadcrumb3: child3,
					childBreadcrumb4: child4,
					childBreadcrumburl: childurl,
					childBreadcrumb1url: child1url,
					childBreadcrumb2url: child2url,
					childBreadcrumb3url: child3url,
					childBreadcrumb4url: child4url
				};
			});
		// console.log(this.breadcrumbs);
	}

	check_url(url, url_name) {
		if (url) {
			this.router.navigate([url]);
		}
	}

	ngOnInit() { }
	goToDashboard() {
		//get role id from session
		const currentUser = localStorage.getItem('currentUser');
		let parsedUser = JSON.parse(currentUser);
		console.log(parsedUser)
		this.role_id = parsedUser.role_id;

		if (this.role_id == 0) {
			this.router.navigate(['/mmportal/employee-dashboard']);
		} else if (this.role_id == 1) {
			this.router.navigate(['/mmportal/employee-dashboard']);
		} else if (this.role_id == 2) {
			this.router.navigate(['/mmportal/employee-dashboard']);
		} else if (this.role_id == 5) {
			this.router.navigate(['/mmportal/employee-dashboard']);
		} else if (this.role_id == 4) {
			this.router.navigate(['/mmportal/employee-dashboard']);
		} else if (this.role_id == 3) {
			this.router.navigate(['/mmportal/employee-dashboard']);
		} else if (this.role_id == 6) {
			this.router.navigate(['/admin/dashboard/librarian-dashboard']);
		} else if (this.role_id == 7) {
			this.router.navigate(['/admin/dashboard/support-staff-dashboard']);
		} else if (this.role_id == 9) {
			this.router.navigate(['/admin/dashboard/parent-dashboard']);
		} else if (this.role_id == 8) {
			this.router.navigate(['/admin/dashboard/student-dashboard']);
		} else if (this.role_id == 12) {
			this.router.navigate(['/admin/dashboard/storekeeper-dashboard']);
		} else if (this.role_id == 11) {
			this.router.navigate(['/admin/dashboard/finance-admin-dashboard']);
		} else if (this.role_id == 10) {
			this.router.navigate(['/admin/dashboard/hr-dashboard']);
		} else {
			this.router.navigate(['/authentication/signin']);
		}
	}
}

// function lookup(name, arr) {
//   for (let i = 0, len = arr.length; i < len; i++) {
//     if (arr[i] === name) {
//       return true;
//     }
//   }
//   return false;
// }
